function cov_1c0azfpvns() {
  var path = "/app/src/utils/check-product-type.tsx";
  var hash = "daacabe2b827ed1f0ff7a85c40850ab46b4c006f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-product-type.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 32
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 9
        },
        end: {
          line: 5,
          column: 37
        }
      },
      "2": {
        start: {
          line: 6,
          column: 9
        },
        end: {
          line: 6,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        loc: {
          start: {
            line: 5,
            column: 9
          },
          end: {
            line: 5,
            column: 37
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 25
          }
        },
        line: 6
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "daacabe2b827ed1f0ff7a85c40850ab46b4c006f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1c0azfpvns = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1c0azfpvns();
import { ProductType } from 'src/types/product-type';
import { createNormalizeChecking } from 'src/utils/create-normalize-checking';
export var checkProductType = (cov_1c0azfpvns().s[0]++, createNormalizeChecking(function (v) {
  cov_1c0azfpvns().f[0]++;
  cov_1c0azfpvns().s[1]++;
  return "".concat(v).trim();
}, function (v) {
  cov_1c0azfpvns().f[1]++;
  cov_1c0azfpvns().s[2]++;
  return v in ProductType;
}, 'The productType parameter has an incorrect value. Please check it', ProductType.default));